import type { PaywallPriceScenario } from "@circle-react/types/PaywallPrice";
import { Price } from "./Price";
import type { PriceComponentProps, PriceScenariosProps } from "./types";

const scenariosResolver: Record<
  PaywallPriceScenario,
  Array<(props: PriceScenariosProps) => React.ReactNode>
> = {
  value: [Price],
  trial_then_value: [Price.Badge, Price.ValueWithArrow],
  trial_then_upfront_then_value: [
    Price.Badge,
    Price.IntroFeeWithArrow,
    Price.ValueWithArrow,
  ],
  upfront_then_value: [Price.IntroFee, Price.ValueWithArrow],
  upfront_then_trial_then_value: [
    Price.IntroFee,
    Price.BadgeWithArrow,
    Price.ValueWithArrow,
  ],
};

export const PriceDisplay = ({
  price,
  paywall,
  reducedPrice,
  couponApplications,
}: PriceComponentProps) => {
  const components = scenariosResolver[price.scenario];

  return (
    <div key={price.id} className="leading-6">
      {components.map((component, index) =>
        component({
          price,
          paywall,
          reducedPrice,
          couponApplication: couponApplications?.applications[index],
        }),
      )}
    </div>
  );
};
